if (!customElements.get('collection-group')) {
  customElements.define(
    'collection-group',
    class CollectionGroup extends HTMLElement {
      constructor() {
        super();
        this.toggleButton = null;
        this.toggleButtonText = null;
        this.items = [];
        this.maxVisible = 0;
        this.handleToggle = this.handleToggle.bind(this);
        this.updateVisibility = this.updateVisibility.bind(this);
      }

      connectedCallback() {
        this.toggleButton = this.querySelector('[data-collection-group-toggle]');
        this.toggleButtonText = this.querySelector('[data-collection-group-toggle-text]');
        this.items = this.querySelectorAll('[data-collection-group-item]');

        if (this.toggleButton) {
          this.toggleButton.addEventListener('click', this.handleToggle);
        }

        window.addEventListener('resize', this.updateVisibility);
        this.updateVisibility();
      }

      disconnectedCallback() {
        if (this.toggleButton) {
          this.toggleButton.removeEventListener('click', this.handleToggle);
        }

        window.removeEventListener('resize', this.updateVisibility);
      }

      handleToggle() {
        if (this.classList.contains('expanded')) {
          this.classList.remove('expanded');
          this.toggleButtonText.textContent = 'Show all';
          this.updateVisibility();
        } else {
          this.classList.add('expanded');
          this.toggleButtonText.textContent = 'Show less';

          this.items.forEach((item) => {
            item.style.display = 'block';
          });
        }
      }

      updateVisibility() {
        if (this.classList.contains('expanded')) return;

        const screenWidth = window.innerWidth;

        if (screenWidth >= 990) {
          this.maxVisible = 22;
        } else if (screenWidth >= 750) {
          this.maxVisible = 10;
        } else if (screenWidth >= 600) {
          this.maxVisible = 8;
        } else {
          this.maxVisible = 6;
        }

        this.items.forEach((item, index) => {
          item.style.display = index < this.maxVisible ? 'block' : 'none';
        });

        if (this.toggleButton) {
          if (this.items.length <= this.maxVisible) {
            this.toggleButton.style.display = 'none';
          } else {
            this.toggleButton.style.display = 'flex';
          }
        }
      }
    },
  );
}
